import isNull from "lodash/isNull"
import isUndefined from "lodash/isUndefined"
import pickBy from "lodash/pickBy"

export function removeEmptyKeys(data) {
  return pickBy(data, (v) => !isNull(v) && !isUndefined(v))
}
